import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FullCalendar from '@fullcalendar/vue';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import TagPicker from 'src/components/Pickers/Tag';
import DateInput from 'src/components/Pickers/DateInput';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
import FromToEntityCard from 'src/components/Dashboard/Calendar/Cards/FromTo';
import Entry from 'src/store/models/Entry';
import Timer from 'src/store/models/Timer';
import Project from 'src/store/models/Project';
import Phase from 'src/store/models/Phase';
import EntrySuggestion from 'src/store/models/EntrySuggestion';
import ProjectUser from 'src/store/models/ProjectUser';
import { dialog } from 'src/boot/mixins.js';
import moment from 'moment';
import { cloneDeep, forEach } from 'lodash';
import TimeInput from 'src/components/Pickers/TimeInput';
import TimePicker from 'src/components/Pickers/Time';
import Todo from 'src/store/models/Todo';
import User from 'src/store/models/User';
import Tag from 'src/store/models/Tag';
import ApprovalRequest from 'src/store/models/ApprovalRequest';
import { colorUtils } from 'src/mixins/colors-utils';
import { BILLING_TYPE as _BILLING_TYPE } from 'src/boot/constants';
import BillableStatusPicker from 'src/components/Pickers/BillableStatus';
export default {
  mixins: [dialog, colorUtils],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker,
    TagPicker: TagPicker,
    TimeInput: TimeInput,
    TimePicker: TimePicker,
    DateInput: DateInput,
    FullCalendar: FullCalendar,
    FromToEntityCard: FromToEntityCard,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade,
    BillableStatusPicker: BillableStatusPicker
  },
  props: {
    type: {
      type: String,
      default: 'entry'
    },
    entity: {
      type: Object
    },
    date: {
      type: String,
      default: null
    },
    copy: {
      type: Boolean,
      default: false
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    projectId: {
      type: Number,
      default: null
    },
    phaseId: {
      type: Number,
      default: null
    },
    todoId: {
      type: Number,
      default: null
    },
    tagIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this$entity$todo_id,
        _this$date,
        _this = this;

    var initialDate = this.entity ? this.entity.date : this.date ? this.date : moment().format('YYYY-MM-DD');
    return {
      calendarViewDate: initialDate,
      custom: false,
      localEntity: {
        type: 'entry',
        client_id: -1,
        project_id: -1,
        phase_id: this.entity ? this.entity.task_id : -1,
        date: null,
        user_id: -1,
        minutes: null,
        seconds: null,
        notes: '',
        tag_ids: [],
        platform: 'web',
        todo_id: this.entity ? (_this$entity$todo_id = this.entity.todo_id) !== null && _this$entity$todo_id !== void 0 ? _this$entity$todo_id : null : null,
        time_from: null,
        time_to: null,
        billed: 0
      },
      optionalFields: {
        tags: {
          label: this.$tc('general.tag', 2),
          icon: 'fal:tags',
          selected: false,
          selectable: true
        },
        todo: {
          label: this.$tc('general.task', 2),
          icon: 'fal:list-check',
          selected: false,
          selectable: true
        },
        notes: {
          label: this.$tc('general.note', 2),
          icon: 'fal:pencil',
          selected: false,
          selectable: true
        }
      },
      billedOptions: [{
        value: 0,
        label: this.$t('general.unbilled')
      }, {
        value: 1,
        label: this.$t('general.billed')
      }, {
        value: 2,
        label: this.$t('general.not_billable')
      }],
      minutes: null,
      loading: false,
      editing: true,
      timerHover: false,
      errors: {
        time: false,
        phase_id: false,
        project_id: false
      },
      calendarOptions: {
        plugins: [interactionPlugin, timeGridPlugin],
        dayHeaders: false,
        initialDate: initialDate,
        scrollTime: this.entity ? moment(this.entity.time_from).subtract(30, 'minutes').format('HH:mm') : moment((_this$date = this.date) !== null && _this$date !== void 0 ? _this$date : moment()).subtract(2, 'hours').format('HH:mm'),
        nowIndicator: true,
        displayEventTime: false,
        // schedulerLicenseKey: '0715888096-fcs-1631280695',
        initialView: 'timeGridDay',
        headerToolbar: false,
        allDaySlot: false,
        nextDayThreshold: '24:00',
        dragRevertDuration: 0,
        firstDay: 1,
        height: '400px',
        eventMinHeight: 20,
        snapDuration: '00:05:00',
        editable: true,
        eventResize: function eventResize(info) {
          _this.localEntity.time_to = moment(info.event.end).format('YYYY-MM-DD HH:mm:ss');
        },
        views: {
          timeGridDay: {
            type: 'timeGrid',
            editable: true
          }
        }
      }
    };
  },
  watch: {
    minutes: 'calculateEntryMinutesAndSeconds',
    calendarViewDate: function calendarViewDate(val) {
      if (this.$refs.fullCalendar) {
        this.$refs.fullCalendar.getApi().gotoDate(val);
      }
    },
    'localEntity.time_from': function localEntityTime_from() {
      if (this.$refs.fullCalendar) {
        this.updateEventMinutes();
      }
    },
    'localEntity.time_to': function localEntityTime_to(val) {
      if (this.$refs.fullCalendar) {
        this.updateEventMinutes();
      }
    },
    'localEntity.project_id': function localEntityProject_id(projectId) {
      this.errors.project_id = false;

      if (projectId > 0) {
        this.onProjectChange();
        var project = Project.query().with('tags').where('project_id', projectId).first();
        this.optionalFields.tags.selectable = !!project && project.tag_usage !== 'NO_TAGS';
        this.optionalFields.todo.selectable = !!project && project.has_todos;
        this.localEntity.project = project;

        if (this.$refs.fullCalendar) {
          this.updateCalendarEvent();
        }

        if (project && project.tag_usage !== 'NO_TAGS') {
          // remove tags that are imported from an integration that doesn't match the new project
          var newFilteredTagsIds = Tag.query().whereIdIn(this.localEntity.tag_ids).where(function (tag) {
            return !tag.integration_project_id || tag.integration_project_id === project.integration_int1;
          }).get().map(function (tag) {
            return tag.tag_id;
          });
          this.localEntity.tag_ids = newFilteredTagsIds.filter(function (tagId) {
            // if the project has linked tags, remove the ones not linked
            if (project.tag_usage === 'LINKED_TAGS') {
              return project.tags.map(function (tag) {
                return tag.tag_id;
              }).includes(tagId);
            } else {
              return true;
            }
          });
        } else {
          // if the project doesn't have tags, clear the tags
          this.localEntity.tag_ids = this.entity && projectId === this.entity.project_id ? this.localEntity.tag_ids : [];
        }
      } else {
        this.optionalFields.tags.selectable = false;
        this.optionalFields.todo.selectable = false;
      }
    },
    'localEntity.phase_id': function localEntityPhase_id() {
      this.errors.phase_id = false;
      this.localEntity.phase = Phase.query().where('task_id', this.localEntity.phase_id).first();

      if (this.$refs.fullCalendar) {
        this.updateCalendarEvent();
      }
    },
    'localEntity.todo_id': function localEntityTodo_id(todoId, oldTodoId) {
      if (oldTodoId) {
        var oldTodo = Todo.query().with('tags').where('todo_id', oldTodoId).first();

        if (oldTodo) {
          this.localEntity.tag_ids = this.localEntity.tag_ids.filter(function (tagId) {
            return !oldTodo.tags.map(function (tag) {
              return tag.tag_id;
            }).includes(tagId);
          });
        }
      }

      if (todoId) {
        var todo = Todo.query().with('tags').where('todo_id', todoId).first();

        if (todo && this.selectedProject && this.selectedProject.tag_usage !== 'NO_TAGS') {
          this.localEntity.tag_ids = Array.from(new Set([].concat(_toConsumableArray(this.localEntity.tag_ids), _toConsumableArray(todo.tags.map(function (tag) {
            return tag.tag_id;
          })))));
          this.localEntity.source = todo.integration_code;
          this.localEntity.source_url = todo.integration_url;
          this.localEntity.source_text = todo.name;
          this.localEntity.source_data = '';
          this.localEntity.source_id = todo.integration_todo_id;
        }
      } else {
        this.deleteSource();
      }
    },
    'localEntity.user_id': function localEntityUser_id(val) {
      if (this.me.account.hasFeature('approval')) {
        ApprovalRequest.api().fetch({
          params: {
            user_ids: [val],
            abridged: 1
          }
        });
      }
    },
    'localEntity.tag_ids': function localEntityTag_ids() {
      this.localEntity.tags = Tag.query().with('tag_list').whereIdIn(this.localEntity.tag_ids).get();

      if (this.$refs.fullCalendar) {
        this.updateCalendarEvent();
      }
    }
  },
  computed: {
    BILLING_TYPE: function BILLING_TYPE() {
      return _BILLING_TYPE;
    },
    showNewRegisterTimeDialog: function showNewRegisterTimeDialog() {
      return this.me.account.hasFeature('from_to');
    },
    canSeeBilling: function canSeeBilling() {
      return this.me.is_admin || Project.$isUserPM(this.localEntity.project_id, this.me.user_id);
    },
    hasCustomDates: function hasCustomDates() {
      return this.custom || (this.entity ? moment(this.entity.time_to).format('YYYY-MM-DD') !== moment(this.entity.time_from).format('YYYY-MM-DD') : false);
    },
    isEntityLocked: function isEntityLocked() {
      return this.entity.locked;
    },
    inputDateMask: function inputDateMask() {
      return this.me.settings.dateFormat.replace(/y/gi, '#').replace(/m/gi, '#').replace(/d/gi, '#');
    },
    unselectedFields: function unselectedFields() {
      var _this2 = this;

      return Object.keys(this.optionalFields).filter(function (field) {
        return !_this2.isFieldSelected(field) && _this2.optionalFields[field].selectable;
      }).map(function (field) {
        return _this2.optionalFields[field];
      });
    },
    dateMask: function dateMask() {
      return this.me.settings.dateFormat.toUpperCase();
    },
    localEntityDate: function localEntityDate() {
      if (this.me.account.hasFeature('from_to')) {
        return this.localEntity.time_from ? moment(this.localEntity.time_from).format('YYYY-MM-DD') : '';
      } else {
        return this.localEntity.date ? moment(this.localEntity.date).format('YYYY-MM-DD') : '';
      }
    },
    quickMinutesOptions: function quickMinutesOptions() {
      // return next 3 options in 15 minute intervals after selected minutes
      var minutes = this.localEntity.minutes;
      return [15, 30, 45].map(function (option) {
        return minutes + option - minutes % 15;
      });
    },
    dateFrom: {
      get: function get() {
        return this.localEntity.time_from ? moment(this.localEntity.time_from).format('YYYY-MM-DD') : '';
      },
      set: function set(value) {
        if (!value) return;
        this.localEntity.time_from = this.setDateTimeDate(this.localEntity.time_from, value);

        if (this.localEntity.time_to && moment(this.localEntity.time_to).isBefore(this.localEntity.time_from)) {
          this.localEntity.time_to = this.setDateTimeDate(this.localEntity.time_to, value);
        }

        if (!this.hasCustomDates) {
          this.localEntity.time_to = this.setDateTimeDate(this.localEntity.time_to, value);
        }

        this.calendarViewDate = value;
      }
    },
    dateTo: {
      get: function get() {
        return this.localEntity.time_to ? moment(this.localEntity.time_to).format('YYYY-MM-DD') : '';
      },
      set: function set(value) {
        this.localEntity.time_to = this.setDateTimeDate(this.localEntity.time_to, value);

        if (this.localEntity.time_from && moment(this.localEntity.time_from).isAfter(this.localEntity.time_to)) {
          this.localEntity.time_from = this.setDateTimeDate(this.localEntity.time_from, value);
        }

        this.calendarViewDate = value;
      }
    },
    maxTimeFrom: function maxTimeFrom() {
      if (this.localEntity.type === 'timer') return moment().format('HH:mm');else return '23:59';
    },
    timeFrom: {
      get: function get() {
        return this.localEntity.time_from ? moment(this.localEntity.time_from).format('HH:mm') : '';
      },
      set: function set(value) {
        this.localEntity.time_from = this.setDateTimeTime(this.localEntity.time_from, value);

        if (this.localEntity.time_to && moment(this.localEntity.time_to).isBefore(this.localEntity.time_from)) {
          this.localEntity.time_to = this.setDateTimeTime(this.localEntity.time_to, moment(value, 'HH:mm').add(this.minutes, 'minutes'));
        }
      }
    },
    timeTo: {
      get: function get() {
        return this.localEntity.time_to ? moment(this.localEntity.time_to).format('HH:mm') : '';
      },
      set: function set(value) {
        this.localEntity.time_to = this.setDateTimeTime(this.localEntity.time_to, value);

        if (this.localEntity.time_from && moment(this.localEntity.time_from).isAfter(this.localEntity.time_to)) {
          this.localEntity.time_from = this.setDateTimeTime(this.localEntity.time_from, value);
        }
      }
    },
    hourlyRate: function hourlyRate() {
      if (this.entity) return this.entity.hourly_rate;
      return 0;
    },
    entityRevenue: function entityRevenue() {
      if (this.entity) return this.entity.revenue;
      return 0;
    },
    tagPickerFilters: function tagPickerFilters() {
      return {
        active: 1,
        project_id: this.localEntity.project_id
      };
    },
    today: function today() {
      return moment().format('YYYY-MM-DD');
    },
    formattedDate: function formattedDate() {
      return moment(this.localEntity.date).format(this.dateMask);
    },
    selectedProject: function selectedProject() {
      return Project.query().with('tag_lists').find(this.localEntity.project_id);
    },
    selectedTodo: function selectedTodo() {
      return Todo.query().with('tags').where('todo_id', this.localEntity.todo_id).first();
    },
    projectRequiresTags: function projectRequiresTags() {
      if (!this.selectedProject) return false;
      return this.selectedProject.requires_tags || this.selectedProject.tag_lists.reduce(function (acc, tagList) {
        return acc || tagList.pivot.required;
      }, false);
    },
    showTaskPicker: function showTaskPicker() {
      // Show task picker if the user has project management and the project has todos
      // and the entry has no source text or the todo is not completed and the todo is from the same project
      // otherwise show the source_text as integration info
      return this.me.account.hasFeature('project_management') && this.selectedProject && this.selectedProject.has_todos && (!this.localEntity.source_text || this.selectedTodo && this.selectedTodo.status !== 'completed' && this.selectedTodo.project_id === this.localEntity.project_id);
    },
    projectFilters: function projectFilters() {
      return {
        active: 1,
        user_id: this.localEntity.user_id,
        abridged: 0,
        api_only: 0
      };
    },
    clientFilters: function clientFilters() {
      return {
        active: 1,
        user_id: this.localEntity.user_id,
        has_active_projects: 1
      };
    },
    formattedSubLabel: function formattedSubLabel() {
      if (this.hourlyRate > 0 && this.localEntity.billed !== 2) {
        var revenue = this.$options.filters.currency(this.entityRevenue);
        var hourlyRate = this.$options.filters.currency(this.hourlyRate);
        return "".concat(this.$t('general.revenue'), ": ").concat(revenue, " (").concat(hourlyRate, "/hr)");
      }

      return '';
    },
    notesRequired: function notesRequired() {
      return this.me.account.settings.required_fields && this.me.account.settings.required_fields.includes('entry_notes');
    },
    notesMissing: function notesMissing() {
      return this.notesRequired && !this.localEntity.notes;
    }
  },
  methods: {
    onUserPickerClick: function onUserPickerClick() {
      if (!this.me.account.hasFeatureAccess('add_time_for_other_users')) {
        this.$refs.addTimeUpgrade.showTooltip();
      }
    },
    dateFilter: function dateFilter(date) {
      if (this.me.account.settings.prosett_entriesLock_enabled && this.me.account.settings.prosett_entriesLock_date) {
        return moment(date).format('YYYY-MM-DD') >= this.me.account.settings.prosett_entriesLock_date && !ApprovalRequest.isDateLockedByApproval(date, this.localEntity.user_id);
      } else {
        return !ApprovalRequest.isDateLockedByApproval(date, this.localEntity.user_id);
      }
    },
    toggleShowNewRegisterTimeDialog: function toggleShowNewRegisterTimeDialog(input) {
      return User.$updateMe({
        settings: {
          showNewRegisterTimeDialog: input
        }
      });
    },
    checkBillablesFeature: function checkBillablesFeature() {
      if (!this.me.account.hasFeatureAccess('billables')) {
        this.$refs.billablesUpgrade.showTooltip();
      }
    },
    isFieldSelected: function isFieldSelected(field) {
      var _this$optionalFields$, _this$optionalFields$2, _this$optionalFields$3, _this$optionalFields$4;

      switch (field) {
        case 'tags':
          return ((_this$optionalFields$ = this.optionalFields[field]) === null || _this$optionalFields$ === void 0 ? void 0 : _this$optionalFields$.selected) || this.localEntity.tag_ids.length > 0 || !!this.projectRequiresTags;

        case 'todo':
          return ((_this$optionalFields$2 = this.optionalFields[field]) === null || _this$optionalFields$2 === void 0 ? void 0 : _this$optionalFields$2.selected) || this.localEntity.todo_id;

        case 'notes':
          return ((_this$optionalFields$3 = this.optionalFields[field]) === null || _this$optionalFields$3 === void 0 ? void 0 : _this$optionalFields$3.selected) || this.localEntity.notes || this.notesRequired;

        default:
          return (_this$optionalFields$4 = this.optionalFields[field]) === null || _this$optionalFields$4 === void 0 ? void 0 : _this$optionalFields$4.selected;
      }
    },
    unselectField: function unselectField(field) {
      switch (field) {
        case 'tags':
          this.localEntity.tag_ids = [];
          break;

        case 'todo':
          this.localEntity.todo_id = null;
          break;

        case 'notes':
          this.localEntity.notes = '';
          break;
      }

      this.optionalFields[field].selected = false;
    },
    selectField: function selectField(field) {
      if (field.feature && !this.me.account.hasFeatureAccess(field.feature)) {
        this.$refs["unselected-".concat(field.feature)][0].showTooltip();
      } else {
        field.selected = true;
      }
    },
    goToPreviousDay: function goToPreviousDay() {
      this.calendarViewDate = moment(this.calendarViewDate).subtract(1, 'day').format('YYYY-MM-DD');
    },
    goToToday: function goToToday() {
      this.calendarViewDate = moment().format('YYYY-MM-DD');
    },
    goToNextDay: function goToNextDay() {
      this.calendarViewDate = moment(this.calendarViewDate).add(1, 'day').format('YYYY-MM-DD');
    },
    setDateTimeDate: function setDateTimeDate(datetime, date) {
      return moment(datetime).set({
        year: moment(date).year(),
        month: moment(date).month(),
        date: moment(date).date()
      }).format('YYYY-MM-DD HH:mm:ss');
    },
    setDateTimeTime: function setDateTimeTime(datetime, time) {
      return moment(datetime).set({
        hour: moment(time, 'HH:mm').hour(),
        minute: moment(time, 'HH:mm').minute()
      }).format('YYYY-MM-DD HH:mm:ss');
    },
    updateCalendarEvent: function updateCalendarEvent() {
      var event = this.$refs.fullCalendar.getApi().getEventById('local-entity');
      var color = this.selectedProject ? this.selectedProject.color : '#27a9e1';
      event.setExtendedProp('entity', this.localEntity);
      event.setProp('backgroundColor', this.adjustColorToRgb(color, 65));
      event.setProp('textColor', this.shadeColor(color, -40));
      event.setProp('borderColor', color); // we have to set editable to true to see a change in the start and end times for timers & suggestions

      event.setProp('editable', true);
      event.setStart(this.localEntity.time_from);
      event.setEnd(this.localEntity.time_from !== this.localEntity.time_to ? moment(this.localEntity.time_to).add(1, 'minute').format('YYYY-MM-DD HH:mm:ss') : moment(this.localEntity.time_from).add(100, 'minute').format('YYYY-MM-DD HH:mm:ss')); // then we need to set editable back to false to prevent nasty users from dragging the events

      event.setProp('editable', this.localEntity.type === 'entry');
    },
    addLocalEntityEventToCalendar: function addLocalEntityEventToCalendar() {
      var color = this.selectedProject ? this.selectedProject.color : '#27a9e1';
      this.$refs.fullCalendar.getApi().addEvent({
        id: 'local-entity',
        title: this.selectedProject ? this.selectedProject.name : this.$t('general.new_entry'),
        entity: this.localEntity,
        start: this.localEntity.time_from,
        end: this.localEntity.time_from !== this.localEntity.time_to ? this.localEntity.time_to : moment(this.localEntity.time_from).add(1, 'minute').format('YYYY-MM-DD HH:mm:ss'),
        backgroundColor: this.adjustColorToRgb(color, 65),
        textColor: this.shadeColor(color, -40),
        borderColor: color,
        editable: this.localEntity.type === 'entry'
      });
    },
    startOrUpdateTimer: function startOrUpdateTimer() {
      var _this$localEntity$sec,
          _this3 = this;

      var timerData = {
        project_id: this.localEntity.project_id,
        phase_id: this.localEntity.phase_id,
        user_id: this.localEntity.user_id,
        seconds: (_this$localEntity$sec = this.localEntity.seconds) !== null && _this$localEntity$sec !== void 0 ? _this$localEntity$sec : this.localEntity.minutes * 60,
        platform: 'web',
        platform_details: 'timer/updateTimer',
        notes: this.localEntity.notes,
        tag_ids: this.localEntity.tag_ids,
        todo_id: this.localEntity.todo_id
      };
      this.localEntity.source && (timerData.source = this.localEntity.source);
      this.localEntity.source_text && (timerData.source_text = this.localEntity.source_text);
      this.localEntity.source_url && (timerData.source_url = this.localEntity.source_url);
      this.localEntity.source_data && (timerData.source_data = this.localEntity.source_data);
      this.localEntity.repeatable_suggestion_id && (timerData.repeatable_suggestion_id = this.localEntity.repeatable_suggestion_id);
      this.localEntity.entry_suggestion_id && (timerData.entry_suggestion_id = this.localEntity.entry_suggestion_id);

      if (this.entity && !this.copy) {
        if (this.type === 'timer') {
          this.showLoading();
          Timer.api().put('/timers/' + this.entity.timer_id, timerData).then(function (result) {
            _this3.hideLoading();

            _this3.$q.notify({
              type: 'positive',
              message: _this3.$t('timer.updated_last_timer')
            }); // this.$root.$emit('refresh-calendar')


            _this3.onOKClick(result.response.data);
          }).catch(function (e) {
            if (e.response) {
              forEach(e.response.data.errors, function (index) {
                _this3.errors[index] = true;
              });
            } else {
              _this3.$q.notify({
                message: _this3.$t('general.an_unexpected_error_occurred'),
                type: 'negative'
              });
            }

            _this3.hideLoading();
          });
        } // Start a new timer

      } else {
        timerData.platform_details = 'timer/startTimer';
        this.showLoading(); // Check if the localEntity has different time worked compared to the entity prop

        if (this.entity && this.entity.entry_suggestion_id && this.localEntity.minutes === this.entity.entry_minutes) {
          // If they are the same and this is a suggestion, start from 0 minutes
          timerData.seconds = 0;
        }

        Timer.api().post('/timers', timerData).then(function (result) {
          if (process.env.GOOGLE_ANALYTICS_ENABLED) {
            window.ueuq = window.uetq || [];
            window.ueuq.push('event', 'timer_start', {});

            if (_this3.$gtag) {
              _this3.$gtag.event('timer_start', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
                debug_mode: true
              } : {});
            }
          }

          _this3.hideLoading();

          _this3.$q.notify({
            type: 'positive',
            message: _this3.$t('timer.timer_started')
          });

          ProjectUser.update({
            where: [_this3.localEntity.project_id, _this3.localEntity.user_id],
            data: {
              last_used: moment().format('YYYY-MM-DD HH:mm:ss'),
              last_used_task_id: _this3.localEntity.phase_id
            }
          });
          Timer.toggleTimerStatus(result.response.data.timer_id);

          if (_this3.type === 'suggestion') {
            EntrySuggestion.delete(_this3.entity.entry_suggestion_id);
          } // this.$root.$emit('refresh-calendar')


          _this3.onOKClick(result.response.data);
        }).catch(function (e) {
          if (e.response) {
            forEach(e.response.data.errors, function (index) {
              _this3.errors[index] = true;
            });
          } else {
            _this3.$q.notify({
              message: _this3.$t('general.an_unexpected_error_occurred'),
              type: 'negative'
            });
          }

          _this3.hideLoading();
        });
      }
    },
    getEntryData: function getEntryData() {
      var data = {
        user_id: this.localEntity.user_id,
        time_from: this.localEntity.time_from,
        date: this.localEntity.date,
        entry_suggestion_id: this.localEntity.entry_suggestion_id,
        repeatable_suggestion_id: this.localEntity.repeatable_suggestion_id || null,
        project_id: this.localEntity.project_id,
        phase_id: this.localEntity.phase_id,
        origin_date: this.localEntity.origin_date,
        notes: this.localEntity.notes,
        time_to: this.localEntity.time_to,
        minutes: this.localEntity.minutes,
        seconds: this.localEntity.seconds,
        platform_details: this.localEntity.platform_details,
        billed: this.localEntity.billed,
        tag_ids: this.localEntity.tag_ids,
        todo_id: this.localEntity.todo_id,
        source: this.localEntity.source,
        source_id: this.localEntity.source_id,
        source_text: this.localEntity.source_text,
        source_url: this.localEntity.source_url,
        suggested_project_id: this.localEntity.suggested_project_id,
        suggested_task_id: this.localEntity.suggested_task_id,
        platform: 'v3'
      };

      if (!this.canSeeBilling) {
        delete data.billed;
      }

      return data;
    },
    saveEntry: function saveEntry() {
      var _this4 = this;

      this.showLoading(); // The entity already exists

      if (this.entity && (this.entity.timer_id || this.entity.entry_suggestion_id || this.entity.entry_id) && !this.copy) {
        if (this.type === 'entry') {
          Entry.api().update(this.entity.entry_id, _objectSpread(_objectSpread({}, this.getEntryData()), {}, {
            platform_details: 'updateEntry'
          })).then(function (result) {
            if (process.env.GOOGLE_ANALYTICS_ENABLED) {
              window.ueuq = window.uetq || [];
              window.ueuq.push('event', 'entry_save', {});

              if (_this4.$gtag) {
                _this4.$gtag.event('entry_save', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
                  debug_mode: true
                } : {});
              }
            }

            _this4.$q.notify({
              type: 'positive',
              message: _this4.$t('entries.updated_entry')
            });

            _this4.hideLoading();

            _this4.onOKClick(result.response.data);
          }).catch(function (e) {
            if (e.response) {
              forEach(e.response.data.errors, function (index) {
                _this4.errors[index] = true;
              });
            } else {
              _this4.$q.notify({
                message: _this4.$t('general.an_unexpected_error_occurred'),
                type: 'negative'
              });
            }

            _this4.hideLoading();
          });
        } else if (this.type === 'timer') {
          // Save a timer as an entry
          var timer = Timer.find(this.entity.timer_id);

          if (timer) {
            timer.$saveAsAnEntry(_objectSpread(_objectSpread({}, this.getEntryData()), {}, {
              platform_details: 'storeTimer'
            })).then(function (result) {
              if (process.env.GOOGLE_ANALYTICS_ENABLED) {
                window.ueuq = window.uetq || [];
                window.ueuq.push('event', 'entry_save', {});

                if (_this4.$gtag) {
                  _this4.$gtag.event('entry_save', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
                    debug_mode: true
                  } : {});
                }
              }

              _this4.$q.notify({
                type: 'positive',
                message: _this4.$t('general.timer_saved')
              });

              _this4.hideLoading(); // this.$root.$emit('refresh-calendar')


              _this4.onOKClick();
            }).catch(function (e) {
              if (e.response) {
                forEach(e.response.data.errors, function (index) {
                  _this4.errors[index] = true;
                });
              } else {
                _this4.$q.notify({
                  message: _this4.$t('general.an_unexpected_error_occurred'),
                  type: 'negative'
                });
              }

              _this4.hideLoading();
            });
          } else {
            this.hideLoading(); // this.$root.$emit('refresh-calendar')

            this.onOKClick();
          }
        } // Save a new entry

      } else {
        Entry.api().store(_objectSpread(_objectSpread({}, this.getEntryData()), {}, {
          entry_suggestion_id: this.localEntity.repeatable_suggestion_id ? null : this.localEntity.entry_suggestion_id,
          platform_details: 'createEntry'
        })).then(function (result) {
          _this4.hideLoading();

          if (_this4.type === 'suggestion' || _this4.type === 'recurrent') {
            EntrySuggestion.delete(_this4.entity.entry_suggestion_id);

            if (typeof _this4.onComplete === 'function') {
              _this4.onComplete();
            }
          }

          ProjectUser.update({
            where: [_this4.localEntity.project_id, _this4.localEntity.user_id],
            data: {
              last_used: moment().format('YYYY-MM-DD HH:mm:ss'),
              last_used_task_id: _this4.localEntity.phase_id
            }
          }); // this.$root.$emit('refresh-calendar')

          if (_this4.me.settings.registerTimeAutoclose === 1) {
            _this4.onOKClick(result.response.data);
          } else {
            _this4.minutes = 0;
            _this4.localEntity = _objectSpread(_objectSpread({}, _this4.localEntity), {}, {
              notes: '',
              tag_ids: [],
              todo_id: null,
              source: '',
              source_url: '',
              source_text: '',
              source_data: '',
              source_id: '',
              minutes: 0,
              seconds: 0,
              repeatable_suggestion_id: null,
              entry_suggestion_id: null,
              type: null,
              platform: 'web'
            });
          }

          _this4.$q.notify({
            type: 'positive',
            message: _this4.$t('components.registerTimeDialog.entry_created')
          });
        }).catch(function (e) {
          if (e.response) {
            forEach(e.response.data.errors, function (index) {
              _this4.errors[index] = true;
            });
          } else {
            _this4.$q.notify({
              message: _this4.$t('general.an_unexpected_error_occurred'),
              type: 'negative'
            });
          }

          _this4.hideLoading();
        });
      }
    },
    updateEventMinutes: function updateEventMinutes() {
      this.minutes = parseInt(moment.duration(moment(this.localEntity.time_to).diff(moment(this.localEntity.time_from))).asMinutes());
      this.updateCalendarEvent();
    },
    calculateEntryMinutesAndSeconds: function calculateEntryMinutesAndSeconds(minutes) {
      this.localEntity.time_from = this.localEntity.type === 'timer' ? moment().subtract(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss') : moment(this.localEntity.time_from).format('YYYY-MM-DD HH:mm:ss');
      this.localEntity.time_to = moment(this.localEntity.time_from).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');
      this.$set(this.localEntity, 'minutes', minutes >= 0 ? minutes : 0);
      this.localEntity.entry_minutes = this.minutes;
      this.localEntity.seconds = minutes >= 0 ? minutes * 60 : 0;
      this.errors.time = false;
    },
    initData: function initData() {
      var _this5 = this;

      if (this.entity && (this.entity.timer_id || this.entity.entry_suggestion_id || this.entity.entry_id)) {
        // sanitize tag_ids
        var tagIds = this.entity.tags ? this.entity.tags.map(function (tag) {
          return tag.tag_id;
        }) : [];
        this.editing = !this.isEntityLocked;
        var project = Project.query().where('project_id', this.entity.project_id).first();
        this.localEntity = _objectSpread(_objectSpread({
          type: this.type,
          suggested_project_id: this.type === 'suggestion' ? this.entity.project_id : null,
          suggested_task_id: this.type === 'suggestion' ? this.entity.task_id : null,
          todo_id: null
        }, cloneDeep(this.entity)), {}, {
          client_id: project && project.client_id > 0 && this.me.settings.registerTimeClientFilter === 1 ? project.client_id : -1,
          phase_id: this.entity.task_id > 0 ? this.entity.task_id : -1,
          tag_ids: tagIds
        });

        if (this.copy && this.type !== 'suggestion' && this.type !== 'recurrent') {
          this.minutes = 0;
        } else {
          if (this.type === 'timer') {
            if (this.entity.timer_status === 'running') {
              this.minutes = parseInt((this.entity.seconds + moment.utc().diff(moment.utc(this.entity.timer_start), 'seconds')) / 60);
            } else {
              this.minutes = parseInt(this.entity.seconds / 60);
            }

            this.localEntity.time_to = moment().format('YYYY-MM-DD HH:mm:ss');
          } else {
            this.minutes = this.entity.entry_minutes;
          }
        }
      } else {
        var lastUsedData = Project.getLastUsedData({
          userId: this.me.user_id,
          projectId: this.projectId
        });
        this.localEntity.type = this.type;
        this.localEntity.user_id = this.me.user_id;
        this.localEntity.project_id = lastUsedData.projectId;
        this.localEntity.phase_id = lastUsedData.phaseId;
        this.onProjectChange();

        if (this.todoId) {
          // dialog opened with todo
          this.localEntity.todo_id = this.todoId;

          if (this.selectedTodo) {
            this.localEntity.source = this.selectedTodo.integration_code;
            this.localEntity.source_text = this.selectedTodo.name;
            this.localEntity.source_url = this.selectedTodo.integration_url;
          }
        }

        if (this.phaseId) {
          // dialog opened with phase
          this.localEntity.phase_id = this.phaseId;
        }

        if (this.tagIds) {
          // dialog opened with tags
          this.localEntity.tag_ids = this.tagIds;
        }

        if (this.date) {
          this.localEntity.date = moment(this.date).format('YYYY-MM-DD'); // check if date is a datetime or a date and if it's missing the time set it to the current time

          if (moment(this.date, 'YYYY-MM-DD HH:mm', true).isValid()) {
            this.localEntity.time_from = moment(this.date).format('YYYY-MM-DD HH:mm:ss');
            this.localEntity.time_to = moment(this.date).add(this.localEntity.minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');
          } else {
            this.localEntity.time_from = this.setDateTimeTime(moment(this.date), moment().format('HH:mm'));
            this.localEntity.time_to = this.setDateTimeTime(moment(this.date), moment().format('HH:mm'));
          }
        } else {
          this.localEntity.date = moment().format('YYYY-MM-DD');
          this.localEntity.time_to = moment().format('YYYY-MM-DD HH:mm:ss');
          this.localEntity.time_from = moment(this.localEntity.time_to).subtract(this.localEntity.minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        }
      }

      this.calculateEntryMinutesAndSeconds();
      setTimeout(function () {
        if (_this5.$refs.fullCalendar) {
          _this5.addLocalEntityEventToCalendar();
        }
      }, 0);
    },
    openLink: function openLink() {
      window.open(this.localEntity.source_url, 'blank');
    },
    deleteSource: function deleteSource() {
      var removeTodoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.localEntity.source = '';
      this.localEntity.source_url = '';
      this.localEntity.source_text = '';
      this.localEntity.source_data = '';
      this.localEntity.source_id = '';

      if (removeTodoId) {
        this.localEntity.todo_id = null;
        this.$emit('update:todoId', null);
      }
    },
    onProjectChange: function onProjectChange() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Project.api().fetchById(_this6.localEntity.project_id, {
                  load: ['tags', 'tagLists']
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetTodo: function resetTodo() {
      if (!this.selectedTodo || this.selectedTodo.project_id) {
        this.localEntity.todo_id = null;
      }
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.initData(); // we add a timeout to make sure the project picker is loaded, without it the ref does not have any time to be
    // rendered

    setTimeout(function () {
      if (_this7.$refs.projectPicker) {
        _this7.$refs.projectPicker.$refs.select.focus();
      }
    }, 0);
  }
};